/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_Hint_LocalityInputs */

const cs_ruian_hint_locality = /** @type {(inputs: Ruian_Hint_LocalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte obec, část, okres nebo kraj pro katalogovou lokalitu.`)
};

const en_ruian_hint_locality = /** @type {(inputs: Ruian_Hint_LocalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a municipality, district, or region for the locality catalog.`)
};

/**
* | output |
* | --- |
* | "Pick a municipality, district, or region for the locality catalog." |
*
* @param {Ruian_Hint_LocalityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_hint_locality = /** @type {((inputs?: Ruian_Hint_LocalityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_Hint_LocalityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_hint_locality(inputs)
	return cs_ruian_hint_locality(inputs)
});